import { useState, useMemo } from "react";
import { Download } from "lucide-react";
import { useAdminData } from "../../hooks/useAdminData";
import { Btn } from "../../components/ui/Btn";
import { Card } from "../../components/ui/Card";
import { PageHeader } from "../../components/ui/PageHeader";
import { SearchBar } from "../../components/ui/SearchBar";
import { StatusBadge } from "../../components/ui/StatusBadge";
import { F, T } from "../../theme/tokens";
import { TableWrap } from "../../components/ui/TableWrap";
import { describeChange } from "../../utils/describeChange";

// ── Audit log ─────────────────────────────────────────────────────────────────

export function AuditView() {
  const { AUDIT_LOG } = useAdminData();
  const [search, setSearch] = useState("");
  const filtered = useMemo(() => AUDIT_LOG.filter((e) => {
    const s = search.toLowerCase();
    return !s || e.action.toLowerCase().includes(s) || e.admin.toLowerCase().includes(s) || e.entityName.toLowerCase().includes(s);
  }), [AUDIT_LOG, search]);

  return (
    <div>
      <PageHeader title="Audit log" sub="Immutable record of all admin actions" actions={
        <Btn variant="ghost" iconOnlyPhone><Download size={13} /> Export log</Btn>
      } />
      <div style={{ marginBottom: "18px" }}>
        <SearchBar value={search} onChange={setSearch} placeholder="Search audit log…" />
      </div>
      <Card>
        <TableWrap><table style={{ width: "100%", borderCollapse: "collapse", fontFamily: F }}>
          <thead>
            <tr style={{ borderBottom: `1px solid ${T.border}` }}>
              {["Timestamp", "Admin", "Action", "Entity", "Change", "Result", "IP"].map((h) => (
                <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: T.muted, letterSpacing: "0.06em", textTransform: "uppercase" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((e) => (
              <tr key={e.id} style={{ borderBottom: `1px solid ${T.border}` }}>
                <td style={{ padding: "11px 14px", fontSize: "10px", fontFamily: "'Space Mono', monospace", color: T.sub, whiteSpace: "nowrap" }}>{e.timestamp}</td>
                <td style={{ padding: "11px 14px", fontSize: "11px", fontWeight: 600, color: T.text, fontFamily: F, whiteSpace: "nowrap" }}>{e.admin}</td>
                <td style={{ padding: "11px 14px", fontSize: "11px", color: T.text, fontFamily: F }}>{e.action}</td>
                <td style={{ padding: "11px 14px" }}>
                  <p style={{ fontSize: "11px", fontWeight: 500, color: T.text, fontFamily: F }}>{e.entityName}</p>
                  <p style={{ fontSize: "9px", color: T.muted, fontFamily: F }}>{e.entityType} · {e.entityId}</p>
                </td>
                <td style={{ padding: "11px 14px", fontSize: "10px", color: T.sub, fontFamily: F }}>
                  {describeChange(e.previousState, e.newState) && <span style={{ overflowWrap: "anywhere" }} title={describeChange(e.previousState, e.newState) ?? undefined}>{describeChange(e.previousState, e.newState)}</span>}
                </td>
                <td style={{ padding: "11px 14px" }}><StatusBadge status={e.result} /></td>
                <td style={{ padding: "11px 14px", fontSize: "10px", fontFamily: "'Space Mono', monospace", color: T.muted }}>{e.ip}</td>
              </tr>
            ))}
          </tbody>
        </table></TableWrap>
      </Card>
    </div>
  );
}
